export default function React_Checkbox() {
  return (
    <div>
      <h1>React_Checkbox Component</h1>
      <p>This is the React_Checkbox tutorial page.</p>
    </div>
  );
}
